import ZJApp from "../../../../app";

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
  service: "TicketService",
  controller: "CheckDetail",
};

const methods = [
  "GetTourist_FlowStat_TimePeriod"
];

const factory = (Fun) => {
  utils.extend(Fun.prototype, info);
  methods.forEach((path) => {
    Fun.prototype[path] = function(data) {
      return this.post(path, data);
    };
  });
};

const TicketResourcesApi = ZJApi.defineNewApi("TicketResourcesApi", factory);

export default TicketResourcesApi;
